<template>
  <el-form ref="ff" label-width="80px" label-position="top" :model="formdata">
    <el-row :gutter="20">
      <el-col :span="12">
        <el-form-item label="报告类别" prop="Type" required>
          <metaPicker
            type="report-type"
            :value.sync="formdata.Type"
            clearable
            @change="pickDate()"
          />
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="报告时段" prop="LastDate" required>
          <el-date-picker
            ref="datePicker"
            v-model="formdata.FirstDate"
            :type="formdata.Type"
            :format="
              formdata.Type == 'month'
                ? 'yyyy年MM月'
                : formdata.Type == 'week'
                ? 'yyyy第WW周'
                : 'yyyy年MM月dd日'
            "
            value-format="yyyy-MM-dd"
            readonly
          />
        </el-form-item>
      </el-col>
    </el-row>
    <el-form-item label="工作总结" prop="Content" required>
      <el-input type="textarea" rows="5" v-model="formdata.Content" />
    </el-form-item>
    <el-form-item label="文件上传">
      <uploader
        ref="uploader"
        :data="{ Mode: 'job-report', ObjectId: formdata.Id }"
        multiple
        :auto-upload="false"
        accept=".jpg,.png,.xls,.xlsx,.pdf,.doc,.docx,.rar,.zip"
      >
        <el-link
          slot="trigger"
          icon="el-icon-upload"
          size="small"
          type="primary"
        >
          选择上传
        </el-link>
      </uploader>
    </el-form-item>
    <el-form-item>
      <el-button type="primary" @click="onSubmit">保存</el-button>
    </el-form-item>
  </el-form>
</template>

<script>
export default {
  components: {
    uploader: () => import("@/views/system/file/multipleUpload"),
    metaPicker: () => import("@/views/system/meta/item/_picker.vue"),
  },
  props: {
    report: { type: Object },
    layerid: { type: String },
  },
  data() {
    return {
      formdata: { Content: null, Type: "date", ...this.report },
    };
  },
  created() {
    this.pickDate();
  },
  methods: {
    //日期选择
    pickDate() {
      console.log(this.formdata.Type);
      let st = new Date();
      let et = st;
      switch (this.formdata.Type) {
        case "week": {
          st = new Date(st.getTime() - 3600 * 1000 * 24 * st.getDay());
          et = new Date(st.getTime() + 3600 * 1000 * 24 * 6);
          break;
        }
        case "month": {
          st = new Date(st.getFullYear(), st.getMonth(), 1);
          et = new Date(st.getFullYear(), st.getMonth() + 1, 0);
          break;
        }
      }
      this.formdata.FirstDate = this.$utils.common.parseTime(st);
      this.formdata.LastDate = this.$utils.common.parseTime(et);
      this.loadSummary();
    },
    //获取总结内容
    loadSummary() {
      this.$apis.job.schedule
        .summary({
          timespan: [this.formdata.FirstDate, this.formdata.LastDate],
          state: 9,
        })
        .then((res) => {
          this.formdata.Content =
            res
              .map((row) => {
                let txt = this.$utils.meta.format("schedule-type", row.text);
                return `${txt}${row.value}次`;
              })
              .join("，") || "没有工作记录";
        });
    },
    //提交数据
    onSubmit() {
      this.$refs["ff"].validate((valid) => {
        if (valid && !this.loading) {
          this.formdata.Code = this.$refs.datePicker.displayValue;
          this.loading = true;
          this.$apis.job.report
            .submit(this.formdata)
            .then((res) => {
              return this.$refs.uploader.onSubmit(res.Id);
            })
            .then(() => {
              this.$message({ message: "数据提交成功！", type: "success" });
              this.$parent.loadData();
              this.$layer.close(this.layerid);
            })
            .catch((e) => {
              this.$message.error(e || "执行错误");
            })
            .finally(() => {
              this.loading = false;
            });
        }
      });
    },
  },
};
</script>